/*
 * @Description:
 * @Autor: lly
 * @Date: 2022-03-14 17:15:45
 * @LastEditors: lly
 * @LastEditTime: 2021-05-12 16:11:59
 */
import axios from 'axios'
import NProgress from 'nprogress'
import { Base64 } from 'js-base64'
import { Message } from 'element-ui'
import { storejs } from '../common/js/util'
import { Deviceinfo } from '../utils/global-methods'

var apiCloudVerify = axios.create({
  baseURL: process.env.VUE_APP_LOGIN_PATH,
  timeout: 10000,
  withCredentials: true
})

if (storejs.get(process.env.APPKEY + 'token')) {
  apiCloudVerify.defaults.headers.common['Authorization'] = 'Bearer ' + storejs.get(process.env.APPKEY + 'token')
}

export function cleanToken() {
  apiCloudVerify.defaults.headers.common['Authorization'] = ''
}

const WhiteList = []
const logArry = [
  '/authentication/loginForm',
  '/authentication/smsLogin',
  '/authentication/loginByUserNameV1',
  `/authentication/wechatlogin`
]

apiCloudVerify.interceptors.request.use(
  function (config) {
    NProgress.start()
    // if (config.method === 'post' && config.url.indexOf("api-exam")<0 && WhiteList.indexOf(config.url) === -1) {
    //   config.data = qs.stringify(config.data);
    // }
    if (logArry.indexOf(config.url) !== -1) {
      const LoginToken = Base64.encode(
        `${ process.env.VUE_APP_CLIENTID }:${ process.env.VUE_APP_CLIENTSECRET }`
      )
      config.headers.Authorization = `Basic ${ LoginToken }`
    } else {
      config.headers.Authorization =
        'Bearer ' + storejs.get(process.env.APPKEY + 'token')
    }
    config.headers.deviceinfo = Deviceinfo()
    return config
  },
  function (error) {
    NProgress.done()
    return Promise.reject(error)
  }
)

// apiCloudVerify.interceptors.response.use(function (response) {
//   NProgress.done();
//   // !response.config.hideMsg  略过错误的msg提示
//   if (response.data.code == 1) {
//     console.log(2)
//     Message.error(response.data.msg);
//     return Promise.reject(response.data);
//   }
//   return response.data;
// }, function (error) {
//   if (!(error.config.url.indexOf("gw/v1/authorizations/jwt") != -1)) {
//     Message.error('网络异常！');
//   }

//   NProgress.done();
//   return Promise.reject(error);
// });

apiCloudVerify.interceptors.response.use(
  function (response) {
    NProgress.done()
    let succRes = response.data
    if (succRes.code != 0) {
      Message.error(succRes.msg)
      return Promise.reject(succRes)
    }
    return succRes
  },
  function (error) {
    let errRes = error.response
    if (errRes && errRes.status !== 200) {
      Message.error({
        message: networkStatus(errRes.status)
      })
    } else if (error.code === 1) {
      Message.error({
        message: error.msg
      })
    }
    NProgress.done()
    return Promise.reject(error)
  }
)

/**
 * @description: 网络状态提示
 * @param {status} 网络状态码
 * @return: 网络状态提示对应信息
 * @author: tanglitong
 */
function networkStatus(status) {
  let errMessage = ''
  switch (status) {
    case 400:
      errMessage = '请求参数错误'
      break
    case 401:
      errMessage = '无权限访问'
      break
    case 404:
      errMessage = '服务不存在'
      break
    case 413:
      errMessage = '上传资源超过服务器限制'
      break
    case 500:
      errMessage = '服务器错误'
      break
    case 503:
      errMessage = '服务器超负荷'
      break
    default:
      break
  }
  return errMessage
}

/**
 * @description: 账号登录
 * @param {type}
 * @author: lly
 */
export const accoutLogin = (params) => {
  return apiCloudVerify.post(`/authentication/loginForm`, params)
}

/**
 * @description: 新账号登录
 */
export const loginByUserNameV1 = (params) => {
  return apiCloudVerify.post(`/authentication/loginByUserNameV1`, params)
}
/**
 * @description: 手机号验证码登录
 * @param {type}
 * @author: lly
 */
export const cellLogin = (params) => {
  return apiCloudVerify.post(`/authentication/smsLogin`, params)
}

/**
 * @description: 发到短信的接口
 * @param {type}
 * @author: lly
 */
export const getsms = (params) => {
  return apiCloudVerify.get(`/v1/sms/send`, {
    params: params
  })
}
/**
 * @description: 短信验证码接口
 * @param {type}
 * @author: lly
 */
export const smsvalidate = (params) => {
  return apiCloudVerify.get(`/v1/sms/validate`, {
    params: params
  })
}
/**
 * @description: 通过uuid发送短信验证码
 */
export const smsSendByUuid = (params) => {
  return apiCloudVerify.get(`/v1/sms/sendByUuid`, {
    params: params
  })
}

/**
 * @description: 验证uuid发送的短信验证码
 */
export const smsValidateByUuid = (params) => {
  return apiCloudVerify.get(`/v1/sms/validateByUuid`, {
    params: params
  })
}

/**
 * @description: 获取用户信息
 * @param {type}
 * @author: lly
 */
export const loginInfo = () => {
  //登录信息
  return apiCloudVerify.get(`/user/getCurrentUser`)
}
/**
 * @description: 微信扫码登录
 */
export const wechatLogin = (params) => {
  //登录信息
  return apiCloudVerify
    .get(`/authentication/wechatlogin`, {
      params
    })
    .then((res) => res.data)
}



// WEBPACK FOOTER //
// ./src/api/apiLoginVerify.js